import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

interface IDummyRadioProps {
  checked?: boolean;
  onClick?: () => void;
}

export const DummyRadio: React.FC<IDummyRadioProps> = forwardRef<
  HTMLButtonElement,
  IDummyRadioProps
>((props, ref) => {
  const { checked, onClick } = props;

  return (
    <button
      ref={ref}
      className={twMerge(
        "flex size-5 items-center justify-center rounded-full border border-base-black",
        checked && "border-green-dark bg-green-light",
      )}
      onClick={onClick}
    >
      {checked && <div className="size-2 rounded-full bg-green-dark"></div>}
    </button>
  );
});
